"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SecondaryButtonShortcut = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _useStyles = require("../../helpers/useStyles");

var _getClassesPropType = require("../../helpers/getClassesPropType");

var _loadStyles = _interopRequireDefault(require("load-styles"));

(0, _loadStyles.default)(".cda04237f{padding:0 .3125rem;display:flex;flex-shrink:0;flex-grow:0}.c6724f2b9{visibility:visible}.c118e164c{visibility:visible}");
var styles = {
  root: 'cda04237f',
  bg: 'c6724f2b9',
  font: 'c118e164c'
};

var SecondaryButtonShortcut = function SecondaryButtonShortcut(props) {
  var classes = props.classes;
  var cn = (0, _useStyles.useStyles)(styles, classes);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: cn.root
  }, /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 44,
    height: 14,
    viewBox: "0 0 44 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react.default.createElement("rect", {
    width: 14,
    height: 14,
    rx: 3,
    fill: "currentColor",
    className: cn.bg
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M4.5 11c.827 0 1.5-.672 1.5-1.5v-.833h2V9.5c0 .828.673 1.5 1.5 1.5s1.5-.672 1.5-1.5c0-.827-.673-1.5-1.5-1.5h-.833V6H9.5c.827 0 1.5-.672 1.5-1.5 0-.827-.673-1.5-1.5-1.5S8 3.673 8 4.5v.834H6V4.5C6 3.673 5.327 3 4.5 3S3 3.673 3 4.5C3 5.328 3.673 6 4.5 6h.833v2H4.5C3.673 8 3 8.673 3 9.5c0 .828.673 1.5 1.5 1.5zm.833-2.333V9.5a.834.834 0 01-1.666 0c0-.459.373-.833.833-.833h.833zm4.167 0a.834.834 0 010 1.667.834.834 0 01-.833-.834v-.833H9.5zM8 8H6V6h2v2zM5.333 5.334H4.5a.834.834 0 010-1.667c.46 0 .833.374.833.833v.834zM9.5 3.667a.834.834 0 010 1.667h-.833V4.5c0-.459.373-.833.833-.833zM21.477 10.404h.955V8.069h2.335v-.955h-2.335V4.78h-.955v2.335h-2.335v.955h2.335v2.335z",
    fill: "currentColor",
    className: cn.font
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: 30,
    width: 14,
    height: 14.001,
    rx: 3,
    fill: "currentColor",
    className: cn.bg
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M34.786 11h4.603v-.945h-3.505V7.83h3.224v-.941h-3.224V4.672h3.462v-.945h-4.56V11zM33 11h8v.001h-8z",
    fill: "currentColor",
    className: cn.font
  })));
};

exports.SecondaryButtonShortcut = SecondaryButtonShortcut;
SecondaryButtonShortcut.propTypes = {
  /* classes */
  classes: (0, _getClassesPropType.getClassesPropType)(styles)
};
SecondaryButtonShortcut.defaultProps = {
  classes: {}
};